import { render, staticRenderFns } from "./stockSalesChart.vue?vue&type=template&id=4c1ea9c6&"
import script from "./stockSalesChart.vue?vue&type=script&lang=js&"
export * from "./stockSalesChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports